import { getFullName } from '@/lib/user'
import common from './common'
import config from '@/config'
import i18next from 'i18next'

export default {
  ...common,
  link: item => {
    return `${config.web}/routine-executions/${item.routine.id}/${item.id}`
  },
  routine: item => item?.routine?.name,
  routineId: item => item.routine.id,
  situation: item => item.situation,
  revId: item => item.revId,
  revType: item => item.revType,
  createdBy: item => getFullName(item.createdBy),
  assignees: item =>
    item?.assignees?.map?.(assignee => getFullName(assignee)).join(', '),
  priority: item => i18next.t(`priority.${item?.priority ?? 'none'}`),
}
